export interface MappedContactRow {
  first_name: string;
  last_name: string;
  phone_work: string;
  company: string;
  tags: string;
  email_work: string;
  title: string;
}

function pick(row: Record<string, string>, keys: string[]): string {
  for (const key of keys) {
    const exact = row[key];
    if (exact?.trim()) {
      return exact.trim();
    }
    const match = Object.keys(row).find(
      (rowKey) => rowKey.toLowerCase() === key.toLowerCase(),
    );
    if (match && row[match]?.trim()) {
      return row[match].trim();
    }
  }
  return "";
}

export function mapImportRow(row: Record<string, string>): MappedContactRow {
  const full = pick(row, [
    "first_name",
    "name",
    "nombre",
    "title",
    "Name",
    "business_name",
  ]);
  const parts = full.split(/\s+/).filter(Boolean);
  const company = pick(row, ["company", "empresa", "name", "nombre"]) || full;

  return {
    first_name: parts[0] || "Sin",
    last_name: parts.slice(1).join(" ") || "nombre",
    phone_work: pick(row, [
      "phone_work",
      "phone",
      "telefono",
      "teléfono",
      "Phone",
    ]),
    company,
    tags: pick(row, ["tags", "category", "types", "categoria", "categoría"]),
    email_work: pick(row, ["email_work", "email", "correo"]),
    title: pick(row, ["title", "cargo"]),
  };
}
